
















































import {
  defineComponent,
  computed,
  reactive,
  ref,
  Ref,
  watch,
} from '@vue/composition-api';
import _ from 'lodash';
import { useRouter, useFormat } from 'vivat';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import PrettyCheck from 'pretty-checkbox-vue/check';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonProductTypeSelect from '@/components/Product/CommonProductTypeSelect.vue';

import getProducts from '@/gql/product/getProducts.gql';
import productTableList from '@/table/product/productList';

const DeliveryList = defineComponent({
  components: {
    PrettyCheck,
    CommonModalWithPreset,
    CommonProductTypeSelect,
  },
  setup() {
    const toCurrency = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    const { router } = useRouter();

    const filter = reactive({
      status: '',
      search: undefined,
      type: undefined,
    });

    const { result: getProductsDetails, loading: getProductsDetailsLoading } = useQuery(getProducts, () => ({}), () => ({
      fetchPolicy: 'network-only',
    }));
    const getTotalProducts = computed(() => getProductsDetails.value?.products?.paginatorInfo?.total || 0);
    const getProductsResult = (data: any) => data.products;

    const computedFilter = computed(() => {
      const vars = {
        where: {},
      };
      if (filter.search) {
        vars.where = {
          OR: [
            {
              column: 'CODE',
              operator: 'LIKE',
              value: `%${filter.search}%`,
            },
            {
              column: 'REF_CODE',
              operator: 'LIKE',
              value: `%${filter.search}%`,
            },
            {
              column: 'NAME',
              operator: 'LIKE',
              value: `%${filter.search}%`,
            },
          ],
        };
      }

      return vars;
    });
    return {
      toCurrency,

      getProductsResult,
      getTotalProducts,

      filter,

      getProducts,
      productTableList,
      computedFilter,

    };
  },
});

export default DeliveryList;
